// extracted by mini-css-extract-plugin
module.exports = {"heading":"PrivacyPolicyPage_heading__3sEKi","content":"PrivacyPolicyPage_content__Hwa6G"};